import {DetailsList, IconButton, PrimaryButton} from "@fluentui/react";
import * as React from "react";
import {useEffect, useState, useContext} from "react";
import {SelectionMode} from "@fluentui/react";
import AppContent from "../Surfaces/AppContent";
import AuthContext from "../Services/AuthContext";
import AddCounter from "../Panel/Counter/AddCounter";
import EditCounter from "../Panel/Counter/EditCounter";
import {Link, useOutletContext} from "react-router-dom";

function Counter(props) {
    const [user] = useContext(AuthContext);
    const [counter, setCounter] = useState([]);
    const [refresh, setRefresh] = useState(0);
    useEffect(() => {
        const abortController = new AbortController();
        async function fetchData() {
            await fetch("/api/counter", {
                method: 'GET',
                signal: abortController.signal,
                headers: {
                    'Authorization': 'Bearer ' + user.token
                }
            }).then(res => res.json())
                .then(data => { setCounter(data) })
                .catch(err => { console.log(err) })
        }
        fetchData();
        return () => abortController.abort();
    }, [refresh, user.token]);
    const [editCounter, setEditCounter] = useState(false);
    const [addCounter, setAddCounter] = useState(false);
    const actions = useOutletContext();
    useEffect(() => {
        actions([
            {
                key: 'addCounter',
                text: 'Dodaj',
                iconProps: { iconName: 'Add' },
                onClick: () => setAddCounter(true)
            }
        ]);
        return actions;
    }, []);

    const columns = [
        {
            key: 'name',
            name: 'Nazwa',
            ariaLabel: 'Nazwa Licznika',
            fieldName: 'name',
            minWidth: 210,
            isRowHeader: true,
            isResizable: true,
            onRender: (item) => (<Link to={`/counter/${item.id}`}><PrimaryButton text={`${item.name}`}/></Link>)
        },
        {
            key: 'edit',
            name: 'Akcje',
            ariaLabel: 'Akcje',
            fieldName: 'edit',
            minWidth: 90,
            maxWidth: 90,
            onRender: (item) => (<span>
                <IconButton iconProps={ {iconName: 'edit' }} title='Edytuj' onClick={() => setEditCounter(item)}/>
                <IconButton iconProps={ {iconName: 'delete' }} title='Usuń' onClick={() => _deleteCounter(item)}/>
            </span>)
        }
    ];
    const _deleteCounter = (item) => {
        fetch(`/api/counter/${item.id}`, {
            method: 'DELETE',
            headers: {
                'Authorization': 'Bearer ' + user.token
            }
        }).then(res => res.json())
            .then(json => { setRefresh(refresh + 1) })
            .catch(err => { console.log(err) })
    }

    return (
        <AppContent title={'Liczniki'}>
            <DetailsList items={counter} columns={columns} selectionMode={SelectionMode.none}/>
            <AddCounter add={addCounter} onSuccess={() => setRefresh(refresh + 1)} dismissPanel={() => setAddCounter(false)} />
            <EditCounter add={editCounter} onSuccess={() => setRefresh(refresh + 1)} dismissPanel={() => setEditCounter(false)} />
        </AppContent>
    );
}

export default Counter;